import React, { useState } from 'react';
import './HireDeveloper.css';

function HireDeveloper() {
  const [formData, setFormData] = useState({
    service: '',
    budget: '',
    name: '',
    phone: '',
    email: '',
    description: '',
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const response = await fetch('/api/send-dev-request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({
          service: '',
          budget: '',
          name: '',
          phone: '',
          email: '',
          description: '',
        });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setStatus('error');
    }
  };

  return (
    <div className="hire-developer-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="glow-effect top-glow"></div>
        <div className="glow-effect bottom-glow"></div>
        <div className="hero-content text-center relative-z">
          <div className="tag-pill">Your Business Technology Partner</div>
          <h1 className="main-heading">
            We Build Businesses...<br />
            <span>Not Just Websites.</span>
          </h1>
          <p className="hero-subtext">
            Need a professional website? Why stop there? From Logo to Launch — Everything Your Business Needs in One Place.
          </p>
          <div className="hero-buttons">
            <a href="#consultation-form" className="btn-primary">Start Your Project</a>
            <a href="#pricing-section" className="btn-secondary">View Pricing</a>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="services-section">
        <div className="section-container text-center">
          <h2 className="section-title">We create everything your business needs to grow.</h2>
          <p className="section-subtitle">Launch your business with ONE developer instead of hiring five different freelancers.</p>
          
          <div className="services-grid">
            {[
              "Custom Websites",
              "iPhone & Android Apps",
              "Logos & Branding",
              "Graphic Design",
              "Promotional Videos",
              "AI Chatbots",
              "Online Booking Systems",
              "Online Stores",
              "Payment Integration",
              "Business Automation"
            ].map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">✅</div>
                <span className="service-name">{service}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* The Hook Comparison */}
      <section className="hook-section">
        <div className="section-container text-center">
          <h2 className="section-title">Need a Website? Why Hire 5 People When One Can Do It All?</h2>
          
          <div className="comparison-grid">
            <div className="comparison-card standard-card">
              <h3 className="card-subtitle">Most developers only offer:</h3>
              <p className="card-title">Website</p>
              <p className="card-note">(And that's it.)</p>
            </div>

            <div className="comparison-card premium-card">
              <h3 className="card-subtitle highlight-text">You offer a complete</h3>
              <p className="card-title text-white">Business Launch Package</p>
              <div className="tags-container">
                {['Brand Identity', 'Logo', 'Website', 'Mobile App', 'Videos', 'Business Cards', 'Flyers', 'Social Media Graphics', 'AI Automation', 'Website Hosting', 'Maintenance', 'Analytics', 'SEO', 'Monthly Improvements'].map((tag, i) => (
                  <span key={i} className="skill-tag">{tag}</span>
                ))}
              </div>
            </div>
          </div>
          
          <p className="hook-conclusion">
            You're selling a complete business solution, not code.
          </p>
        </div>
      </section>

      {/* Pricing Packages */}
      <section id="pricing-section" className="pricing-section">
        <div className="section-container text-center">
          <h2 className="section-title">Build Today. Pay Monthly.</h2>
          <p className="section-subtitle">
            No huge upfront investment. Launch now. Grow as you go. Instead of charging $8,000 for a large project, make it easier with accessible monthly plans.
          </p>

          <div className="pricing-grid">
            {/* Starter */}
            <div className="pricing-card">
              <h3>Starter</h3>
              <div className="price-box">
                <p className="price-label">Down Payment</p>
                <p className="price-value">$399 <span>Down</span></p>
                <p className="price-label mt-3">Then</p>
                <p className="price-value">$149<span>/month</span></p>
              </div>
              <ul className="feature-list">
                {["Professional Website", "Contact Forms", "Mobile Friendly", "SSL", "Hosting", "Monthly Updates", "Basic SEO", "Analytics", "Maintenance"].map((f, i) => (
                  <li key={i}>✅ {f}</li>
                ))}
              </ul>
              <a href="#consultation-form" className="btn-package">Select Starter</a>
            </div>

            {/* Business */}
            <div className="pricing-card popular-card">
              <div className="popular-badge">MOST POPULAR</div>
              <h3>Business</h3>
              <div className="price-box">
                <p className="price-label highlight">Down Payment</p>
                <p className="price-value text-white">$699 <span className="light">Down</span></p>
                <p className="price-label highlight mt-3">Then</p>
                <p className="price-value text-white">$249<span className="light">/month</span></p>
              </div>
              <ul className="feature-list">
                <li className="bold-feature">✅ Everything in Starter, PLUS:</li>
                {["Online Booking", "Payment Processing", "Blog", "CRM Integration", "Email Marketing", "Advanced SEO", "Social Media Integration", "Monthly Performance Reports"].map((f, i) => (
                  <li key={i}>✅ {f}</li>
                ))}
              </ul>
              <a href="#consultation-form" className="btn-package highlight-bg">Select Business</a>
            </div>

            {/* Ultimate Business */}
            <div className="pricing-card">
              <h3>Ultimate Business</h3>
              <div className="price-box">
                <p className="price-label">Down Payment</p>
                <p className="price-value">$999 <span>Down</span></p>
                <p className="price-label mt-3">Then</p>
                <p className="price-value">$399<span>/month</span></p>
                <p className="price-subnote">For 24 months</p>
              </div>
              <ul className="feature-list">
                <li className="bold-feature">✅ Everything included, PLUS:</li>
                {["iPhone App", "Android App", "Admin Dashboard", "AI Chatbot", "Custom API Integrations", "User Accounts", "Push Notifications", "Video Marketing Assets", "Ongoing Feature Development"].map((f, i) => (
                  <li key={i}>✅ {f}</li>
                ))}
              </ul>
              <a href="#consultation-form" className="btn-package">Select Ultimate</a>
            </div>
          </div>
        </div>
      </section>

      {/* Subscription Benefits */}
      <section className="benefits-section">
        <div className="section-container text-center">
          <h2 className="section-title">Monthly Subscription Benefits</h2>
          <p className="section-subtitle">Every monthly client receives an ongoing partnership, not just a maintenance fee.</p>
          
          <div className="benefits-grid">
            {[
              "Website hosting", "SSL certificate", "Security updates", "Bug fixes", 
              "Monthly backups", "Performance optimization", "SEO improvements", 
              "New content updates", "Graphic design requests", "Technical support", 
              "Analytics reports", "Consultation", "Priority response", "Ongoing feature enhancements"
            ].map((benefit, idx) => (
              <div key={idx} className="benefit-item">
                <span className="check-icon">✅</span> {benefit}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Showcase */}
      <section className="portfolio-section">
        <div className="section-container text-center">
          <h2 className="section-title">Our Complete Capabilities</h2>
          <p className="section-subtitle">Explore what we can build for you as your technology partner.</p>

          <div className="portfolio-grid">
            {[
              { icon: '🌐', title: 'Websites', items: ['Business websites', 'E-commerce', 'Landing pages', 'Dashboards'] },
              { icon: '📱', title: 'Mobile Apps', items: ['React Native', 'Flutter', 'iOS', 'Android'] },
              { icon: '🎨', title: 'Graphic Design', items: ['Logos', 'Flyers', 'Business cards', 'Social media posts', 'UI/UX mockups'] },
              { icon: '🎬', title: 'Video Production', items: ['Product demos', 'Promotional videos', 'App walkthroughs', 'Social media ads', 'Motion graphics'] },
              { icon: '🤖', title: 'AI & Automation', items: ['AI chatbots', 'Customer support bots', 'Booking automation', 'Workflow automation'] },
              { icon: '💼', title: 'Business Systems', items: ['Inventory', 'POS', 'Booking systems', 'CRM', 'Membership platforms', 'Auction platforms', 'Social media platforms'] }
            ].map((port, idx) => (
              <div key={idx} className="portfolio-card">
                <div className="port-icon">{port.icon}</div>
                <h3>{port.title}</h3>
                <ul>
                  {port.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section id="consultation-form" className="form-section">
        <div className="section-container text-center">
          <h2 className="section-title">Ready to launch your business?</h2>
          <p className="section-subtitle">Stop worrying about the tech. Let us handle the development, design, and systems while you focus on growing your business. Book a consultation today.</p>

          <form className="hire-dev-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="service">Select Development Service</label>
              <select id="service" name="service" value={formData.service} onChange={handleChange} required>
                <option value="">-- Choose Service --</option>
                <option value="business_starter">Business Launch - Starter</option>
                <option value="business_pro">Business Launch - Business</option>
                <option value="business_ultimate">Business Launch - Ultimate</option>
                <option value="mobile_app">Custom Mobile App</option>
                <option value="web_app">Custom Website / Web App</option>
                <option value="other">Other / Custom Request</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="budget">Project Budget / Package</label>
              <select id="budget" name="budget" value={formData.budget} onChange={handleChange} required>
                <option value="">-- Select Budget --</option>
                <option value="starter">$399 Down / $149 Monthly</option>
                <option value="business">$699 Down / $249 Monthly</option>
                <option value="ultimate">$999 Down / $399 Monthly</option>
                <option value="custom_5k">$5,000+</option>
                <option value="custom_10k">$10,000+</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your full name" required />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone number" required />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required />
            </div>

            <div className="form-group">
              <label htmlFor="description">Project Description</label>
              <textarea id="description" name="description" value={formData.description} onChange={handleChange} placeholder="Describe your project goals..." required></textarea>
            </div>

            <button type="submit" disabled={status === 'sending'} className="btn-submit">
              {status === 'sending' ? 'Sending Request...' : 'Submit Consultation Request'}
            </button>

            {status === 'success' && <p className="success-msg">Request sent successfully!</p>}
            {status === 'error' && <p className="error-msg">Failed to send request. Please try again.</p>}
          </form>
        </div>
      </section>
    </div>
  );
}

export default HireDeveloper;